<section class="hd-profile-lines-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-profile-lines-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-profile-lines-cheat-sheet-page__controls" aria-label="Profile lines cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-profile-lines-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-profile-lines-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-profile-lines-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }

  <div class="hd-profile-lines-cheat-sheet-page__deck">
    <div class="hd-profile-lines-cheat-sheet-page__grid">
      @for (card of cards(); track card.line) {
        <!-- Profiellijn-kaart -->
        <article class="profile-line-card" [style.--line-color]="card.color">
          <header class="profile-line-card__header">
            <div class="profile-line-card__header-left">
              <p class="profile-line-card__kicker">{{ cardTitle() }}</p>
              <h3 class="profile-line-card__name">{{ card.name }}</h3>
            </div>
            <div class="profile-line-card__header-right">
              <span class="profile-line-card__number">{{ card.line }}</span>
              <span class="profile-line-card__keyword">{{ card.keyword }}</span>
              <span class="profile-line-card__keyword2">{{ card.keyword2 }}</span>
            </div>
          </header>
          <div class="profile-line-card__body">
            <p class="profile-line-card__text" [innerHTML]="card.description"></p>
            <p class="profile-line-card__text profile-line-card__text--plus" [innerHTML]="card.plus"></p>
            <p class="profile-line-card__text profile-line-card__text--minus" [innerHTML]="card.minus"></p>
          </div>
          <footer class="profile-line-card__meta">{{ card.meta }}</footer>
        </article>

        <!-- Tips-voor-kids-kaart -->
        <article class="profile-line-card profile-line-card--kids" [style.--line-color]="card.color">
          <header class="profile-line-card__header">
            <div class="profile-line-card__header-left">
              <p class="profile-line-card__kicker">{{ kidsTitle() }}</p>
              <h3 class="profile-line-card__name">{{ card.name }}</h3>
            </div>
            <div class="profile-line-card__header-right">
              <span class="profile-line-card__number">{{ card.line }}</span>
              <span class="profile-line-card__keyword">{{ card.keyword }}</span>
              <span class="profile-line-card__keyword2">{{ card.keyword2 }}</span>
            </div>
          </header>
          <div class="profile-line-card__body">
            <p class="profile-line-card__kids-intro" [innerHTML]="kidsIntro()"></p>
            <ul class="profile-line-card__bullets">
              @for (tip of card.kids; track $index) {
                <li>{{ tip }}</li>
              }
            </ul>
          </div>
          <footer class="profile-line-card__meta">{{ card.meta }}</footer>
        </article>
      }
    </div>
  </div>
</section>
